(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('LicenceCode', LicenceCode)
        .factory('LicenceType', LicenceType)
        .factory('Vendor', Vendor);

    LicenceCode.$inject = ['$resource', 'DateUtils'];

    function LicenceCode($resource, DateUtils) {
        var resourceUrl = 'api/licence-code/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'save': {method: 'POST', url:'api/licence-code/save-new'},
            'get': {method: 'GET', url:'api/licence-code/licence-id/:id'},
            'getByVendor': {
                method: 'GET',
                url: 'api/licence-code/by-vendor/:id/:status',
                isArray: true
            },
            'active': {method: 'PUT', url:'api/licence-code/active'},
            'activeLicence': {
                method: 'GET',
                url: 'api/licence-code/active-licence/:id',
                isArray: true
            },
            'update': {method: 'PUT', url:'api/licence-code/update'},
            'getDomains': {method: 'GET', url: 'api/licence-code/domains', isArray: true}
        });
    }

    LicenceType.$inject = ['$resource', 'DateUtils'];

    function LicenceType($resource, DateUtils) {
        var resourceUrl = 'api/licence-type/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }

    Vendor.$inject = ['$resource', 'DateUtils'];

    function Vendor($resource, DateUtils) {
        var resourceUrl = 'api/vendor/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'create': {method: 'PUT', url:'api/vendor/create-new'}
        });
    }
})();
